import { ODSButton } from '@telekom-ods/react-ui-kit';
import PropTypes from 'prop-types';

const Button = ({
  type = 'button',
  buttonType = 'standard',
  label = 'Submit',
  size = 'small',
  variant = 'primary',
  disabled = false,
  href = null,
  download = null,
  onClick = null,
  icon = null,
  leftIcon = false,
  rightIcon = false,
}) => {
  const odsButton = (
    <ODSButton
      type={type}
      variant={variant}
      label={label}
      buttonType={buttonType}
      size={size}
      disabled={disabled}
      onClick={onClick}
      buttonIcon={icon}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      href={href}
    >
      {label}
    </ODSButton>
  );

  // If download is provided, wrap the button in an anchor tag
  // to enable downloading functionality
  if (download) {
    return (
      <a href={href} download={download} style={{ textDecoration: 'none' }}>
        {odsButton}
      </a>
    );
  }

  return odsButton;
};

Button.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
  href: PropTypes.string,
  download: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string,
  icon: PropTypes.node,
  disabled: PropTypes.bool,
  leftIcon: PropTypes.bool,
  rightIcon: PropTypes.bool,
  buttonType: PropTypes.string,
};

export default Button;
